export const defaultPlaceholderHiddenText = "•".repeat(10);
//# sourceMappingURL=defaults.js.map